import { useCallback } from 'react';
import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

const ToggleContainer = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  gap: '12px',
  width: '100%',
})``;

const ToggleLabel = styled(Text).attrs({
  size: 'small',
  color: 'secondaryText',
  fontWeight: 'semibold',
})`
  flex-shrink: 0;
  white-space: nowrap;
  margin-right: 8px;
`;

const ToggleSwitch = styled.button`
  position: relative;
  width: 32px;
  height: 18px;
  background: ${({ theme, $isOn }) =>
    $isOn ? theme.colors.success : theme.colors.lightLineDivider};
  border: none;
  border-radius: 12px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ $isOn }) => ($isOn ? '16px' : '2px')};
    width: 14px;
    height: 14px;
    background: ${({ theme }) => theme.colors.background};
    border-radius: 50%;
    transition: left 0.2s ease;
  }

  &:hover:not(:disabled) {
    background: ${({ theme, $isOn }) =>
      $isOn ? theme.colors.successDark : theme.colors.heavyLineOutline};
  }
`;

const ToggleWrapper = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  gap: '8px',
})`
  flex: 1;
`;

const ToggleText = styled(Text).attrs({
  size: 'small',
  fontWeight: 'medium',
})`
  margin-left: 8px;
`;

const TranslationToggle = ({ isOn = false, onChange, disabled = false }) => {
  const handleToggle = useCallback(() => {
    if (!disabled) {
      onChange(!isOn);
    }
  }, [disabled, isOn, onChange]);

  return (
    <ToggleContainer
      data-name="translation-toggle-container"
      data-testid="translation-toggle-container"
    >
      <ToggleLabel title="Display transcript in native or translated language">
        Translation:
      </ToggleLabel>
      <ToggleWrapper>
        <ToggleSwitch
          $isOn={isOn}
          onClick={handleToggle}
          disabled={disabled}
          aria-label={`Translation ${isOn ? 'on' : 'off'}`}
          data-name="translation-toggle-switch"
          data-testid="translation-toggle-switch"
        />
        <ToggleText color={disabled ? 'secondaryText' : 'primaryText'}>
          {isOn ? 'On' : 'Off'}
        </ToggleText>
      </ToggleWrapper>
    </ToggleContainer>
  );
};

export default TranslationToggle;
